import { FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { AddProductDialog, AddProductDialogProps } from './AddProductDialog';
import { TwoStepAddProductDialog } from './TwoStepProductDialog/TwoStepAddProductDialog';

export const PolymorphicProductDialog = (dialogProps: AddProductDialogProps) => {
    const twoStepVariantEnabled = useFeatureFlag(FeatureFlag.twoStepAddProductDialog);

    return twoStepVariantEnabled ? <TwoStepAddProductDialog {...dialogProps} /> : <AddProductDialog {...dialogProps} />;
};
